import { useEffect, useState } from "react";
import { formatClock, formatDateTime } from "../../lib/i18n/format";

/**
 * The venue clock: the viewer's own zone, absolute, in tabular digits. Ticks to the minute — no seconds flicker. Hidden on phones, where
 * the top bar has no room and the device shows the time anyway.
 */
export function BandClock({ tone = "board" }: { tone?: "board" | "paper" }) {
	const [now, setNow] = useState(() => new Date());
	useEffect(() => {
		const id = window.setInterval(() => setNow(new Date()), 15_000);
		return () => window.clearInterval(id);
	}, []);
	return (
		<time
			dateTime={now.toISOString()}
			title={formatDateTime(now)}
			className={`hidden font-bold font-mono tabular-nums sm:block ${
				tone === "board" ? "text-[1.125rem] text-white" : "text-[0.9375rem] text-ink"
			}`}
		>
			{formatClock(now)}
		</time>
	);
}
